/**
 * RESPONSIBILITY: the words above the home page's ministry grid.
 *
 * The ministries themselves are the one Ministries list, edited in one place. This band
 * only decides what the home page calls it and how many it shows.
 *
 * No @EditableBy, so WRITE defaults to NONE - admin only.
 */
import { Section, Text, Link, Num } from '@framework/core/decorators';
import { SectionName } from '../section-names';
import { LINK_HINT, COUNT_HINT } from '../hints';

@Section({ name: SectionName.HomeMinistries, label: 'Home - Ministries band' })
export class HomeMinistriesSection {
  @Text({
    label: 'Subtitle above', maxLength: 120,
    description: 'The small gold line above the title, e.g. Get involved. Leave empty for none.',
  })
  eyebrow!: string;
  @Text({ label: 'Title', maxLength: 120, default: 'Church Ministries' }) heading!: string;
  @Text({ label: 'Subtitle', maxLength: 600, description: 'The line under the title.' })
  intro!: string;
  @Text({ label: 'Button text', maxLength: 120, default: 'All ministries' }) linkLabel!: string;
  @Link({ label: 'Button link', default: '#ministry', description: LINK_HINT }) linkHref!: string;
  @Num({
    label: 'How many to show', min: 1, max: 24, integer: true, default: 8,
    description: COUNT_HINT,
  })
  count!: number;
}
